"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMenuClickHandlers = exports.goOut = exports.goTo = void 0;
const react_1 = require("react");
const url_join_1 = __importDefault(require("url-join"));
const services_1 = require("../../services");
const utils_1 = require("../../utils");
const { privacyPolicy, termsOfUse, urlText } = utils_1.envConfig;
const goTo = (url, prefixWithDomain = true, onClose) => {
    onClose === null || onClose === void 0 ? void 0 : onClose();
    window.location.href = prefixWithDomain ? (0, url_join_1.default)(urlText || '', url) : url;
};
exports.goTo = goTo;
const goOut = (url, onClose) => {
    onClose === null || onClose === void 0 ? void 0 : onClose();
    window.open(url, '_blank');
};
exports.goOut = goOut;
function useMenuClickHandlers({ facetsConfig, toggleModalShare, onClose, }) {
    const handleCatalogClick = (catalogUrl) => () => {
        tagMenuClick('menu:catalogo');
        (0, exports.goTo)(catalogUrl);
    };
    const handleCategoryItemClick = (0, react_1.useCallback)((item) => {
        const c = item.slugName || item.name;
        const category = c === 'Promoções' ? 'promocao' : c;
        tagMenuClick(`menu:categorias:${(0, utils_1.slugfy)(c)}`);
        const url = encodeURI(`/${facetsConfig.catalogSlug}/categoria?category=${category}`);
        (0, exports.goTo)(url);
    }, [facetsConfig.catalogSlug]);
    const handleBrandItemClick = (0, react_1.useCallback)((item) => {
        const brand = item.slugName || item.name;
        tagMenuClick(`menu:marca:${(0, utils_1.slugfy)(brand)}`);
        const url = encodeURI(`/${facetsConfig.catalogSlug}/marca?brand=${brand}`);
        (0, exports.goTo)(url);
    }, [facetsConfig.catalogSlug]);
    const handlePromptDeliveryClick = (0, react_1.useCallback)(() => {
        tagMenuClick('menu:pronta-entrega');
        const url = encodeURI(`/${facetsConfig.catalogSlug}/pronta-entrega`);
        (0, exports.goTo)(url);
    }, [facetsConfig.catalogSlug]);
    const handleShareCatalogClick = (0, react_1.useCallback)((urlCatalog) => () => __awaiter(this, void 0, void 0, function* () {
        tagMenuClick('menu:compartilhar-catalogo');
        const hasNativeShareApi = yield (0, utils_1.shareNatively)({ url: (0, url_join_1.default)(urlText || '', urlCatalog) });
        if (!hasNativeShareApi) {
            toggleModalShare === null || toggleModalShare === void 0 ? void 0 : toggleModalShare();
        }
        onClose === null || onClose === void 0 ? void 0 : onClose();
    }), [onClose, toggleModalShare]);
    const handlePrivacyPolicyClick = () => {
        tagMenuClick('menu:termos-legais:termo');
        (0, exports.goOut)(privacyPolicy || '');
    };
    const handleTermsOfUseClick = () => {
        tagMenuClick('menu:termos-legais:politica');
        (0, exports.goOut)(termsOfUse || '');
    };
    return {
        handleCatalogClick,
        handleCategoryItemClick,
        handleBrandItemClick,
        handlePromptDeliveryClick,
        handleShareCatalogClick,
        handlePrivacyPolicyClick,
        handleTermsOfUseClick,
    };
}
exports.useMenuClickHandlers = useMenuClickHandlers;
function tagMenuClick(eventLabel) {
    services_1.GoogleAnalyticsService.event({
        event: 'ga-event',
        'event-category': 'tab-bar',
        'event-action': 'click',
        'event-label': eventLabel,
    });
}
